import React, { useState } from 'react';
import {
    Heading,
    DesktopSearch,
    SubHeading,
    MobileSearch,
    StyledSortIcon,
} from './InventorySearch.styled';
import HighlightSearch from './HighlightSearch';
import Select from 'src/common/refactoredComponents/select/Select';
import SortGeneral from 'src/assets/images/SortGeneral.svg';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getInventoryDetails, setInventoryItems } from '../../redux/actions';
import { VISIBLE } from 'src/constants/appConstants';
const InventorySearch = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const options = [
        {
            value: 'cfn_ASC',
            label: t('consignmentBilling.inventory.itemAscending'),
            className: 'customFontDropDown',
        },
        {
            value: 'cfn_DESC',
            label: t('consignmentBilling.inventory.itemDescending'),
            className: 'customFontDropDown',
        },
        {
            value: 'useByDate_ASC',
            label: t('consignmentBilling.inventory.useByDateAscending'),
            className: 'customFontDropDown',
        },
        {
            value: 'useByDate_DESC',
            label: t('consignmentBilling.inventory.useByDateDescending'),
            className: 'customFontDropDown',
        },
        {
            value: 'batch_ASC',
            label: t('consignmentBilling.inventory.lotSerialNumberAscending'),
            className: 'customFontDropDown',
        },
        {
            value: 'batch_DESC',
            label: t('consignmentBilling.inventory.lotSerialNumberDescending'),
            className: 'customFontDropDown',
        },
        {
            value: 'onhand_ASC',
            label: t('consignmentBilling.inventory.quantityOnHandAscending'),
            className: 'customFontDropDown',
        },
        {
            value: 'onhand_DESC',
            label: t('consignmentBilling.inventory.quantityOnHandDescending'),
            className: 'customFontDropDown',
        },
    ];
    const [selectedOption, setselectedOption] = useState(
        t('consignmentBilling.inventory.useByDateAscending')
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const {
        accountId,
        patientFirstName,
        patientLastName,
        physicianName,
        hrefId,
        patient_Details,
        specialStockPartner,
        specialStockPartnerVisibility,
    } = useSelector((state) => ({

        accountId: state.consignmentReducer.surgeryDetails.accountId,
        patientFirstName:
            state.consignmentReducer.surgeryDetails.patientFirstName,
        patientLastName:
            state.consignmentReducer.surgeryDetails.patientLastName,
        physicianName:
            countryISOCode === 'JP'
                ? state.consignmentReducer.surgeryDetails.physicianId
                      .physicianDisplayName
                : state.consignmentReducer.surgeryDetails.physicianId,
        hrefId: state.consignmentReducer.surgeryDetails.hrefId,
        patient_Details: state.loginReducer?.patient_Details,
        specialStockPartner:
            state.consignmentReducer.surgeryDetails.specialStockPartnerDetails,
        specialStockPartnerVisibility:
            state.loginReducer.specialStockPartnerDetails,
    }));
    const {isCondensedView, isLanguageChanged} = useSelector(
        (state) => state.loginReducer
    );
    const checkedItems = useSelector(
        (state) => state.inventoryReducer.checkedItems
    );
    const { isShortTermConsignment } = useSelector((state) => ({
        isShortTermConsignment:
            state.consignmentReducer.surgeryDetails.isShortTermConsignment,
    }));

    const handleFilterChange = (selectedOption) => {
        let sortParams = selectedOption.split('_', 2);
        const payload = {
            accountNumber:
                specialStockPartnerVisibility === VISIBLE &&
                specialStockPartner
                    ? specialStockPartner?.sbNumber
                    : accountId.accountId,
            productType: 'tissue',
            orderType: 'KE',
            resourceType: 'INVENTORY_LIST',
            sortCode: sortParams[0],
            sortOrder: sortParams[1],
            currentPage: '0',
            filterParam: 'all',
            searchQuery: props.searchItem,
            pageSize: '50',
            isBKPProductsDisplay: isShortTermConsignment ? true : false,
        };
        dispatch(getInventoryDetails(payload));
        setselectedOption(selectedOption);
    };

    const clearSelectedClickHandler = () => {
        const selectedItemIds = props.checked
            .filter((x) => x.isChecked)
            .map((y) => y.cfn);
        const modifiedGridData = props.checked.map((obj) => ({
            ...obj,
            itemDetails: selectedItemIds.includes(obj.cfn)
                ? null
                : obj.itemDetails,
            isChecked: false,
        }));
        dispatch(setInventoryItems([]));
        props.setChecked(modifiedGridData);
        props.setModifiedData([]);
        props.setFilterCheckedItems([]);
        props.setItemCheckedCount(0);
        props.setClearAll(true);
    };
    return (
        <>
            <DesktopSearch>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                        <SubHeading isDemi>
                            {t(
                                'consignmentBilling.inventory.searchWithinInventory'
                            )}
                        </SubHeading>
                    </div>
                    <div style={{ margin: 'auto' }}>
                        <HighlightSearch
                            setSearchItem={props.setSearchItem}
                            setShowBtn={props.setShowBtn}
                        />
                    </div>
                </div>

                <Button
                    id={'consignmentBilling-inventorySearch-inventory-search'}
                    show
                    // secondary
                    variant={
                        checkedItems && checkedItems.length > 0
                            ? ButtonStyles?.secondary
                            : ButtonStyles?.disabled
                    }
                    width={isCondensedView ? 'auto' : '111px'}
                    mobileWidth={'109px'}
                    height={'33px'}
                    clicked={clearSelectedClickHandler}
                    margin={'5px'}
                    mobileMargin={'5px 0px 5px 5px'}
                    WhiteSpace={'nowrap'}
                    fontSize={'13px'}
                    border={'1px solid #EBEBEB'}
                    borderRadius={'20px'}
                    color={
                        checkedItems && checkedItems.length > 0
                            ? '#1010EB'
                            : '#B2B2B2'
                    }
                    padding={isCondensedView ? '6px 15px' : '0px '}
                    disabled={
                        checkedItems && checkedItems.length > 0 ? false : true
                    }
                >
                    {t('consignmentBilling.inventory.clearAll')}
                </Button>
            </DesktopSearch>
            <MobileSearch>
                <div style={{ display: 'block', paddingTop: '10px' }}>
                    <div>
                        <Heading className="consignment-billing-inventory-search-account-dt-mask" isDemi>
                            {accountId?.accountName}{' '}
                            <Heading isItalic>
                                {accountNumberZeroTrimmer(
                                    accountId?.accountId || ''
                                )}{' '}
                            </Heading>
                        </Heading>
                    </div>

                    <div style={{ marginTop: '-7px' }}>
                        <Heading className="consignment-billing-inventory-search-account-dt-mask" isDemi>
                            {physicianName
                                ? `${t('common.drLabel')} ${
                                      typeof physicianName === 'string'
                                          ? physicianName
                                          : physicianName?.physicianDisplayName
                                  }`
                                : ''}
                            {patient_Details?.includes('Patient Name') &&
                                patientFirstName && (
                                    <Heading isRegular>
                                        {' '}
                                        {patientFirstName && physicianName && (
                                            <span
                                                style={{ paddingLeft: '4px' }}
                                            >
                                                |
                                            </span>
                                        )}{' '}
                                        <span
                                            style={{
                                                paddingLeft: physicianName
                                                    ? '4px'
                                                    : '0px',
                                            }}
                                        >
                                            {t(
                                                'consignmentBilling.inventory.patient'
                                            )}
                                        </span>{' '}
                                        {patientFirstName +
                                            ' ' +
                                            patientLastName}{' '}
                                    </Heading>
                                )}
                        </Heading>
                        <div style={{ marginTop: '-5px' }}>
                            {patient_Details?.includes(
                                'Hospital Patient Ref'
                            ) &&
                                hrefId && (
                                    <Heading isRegular>
                                        <span style={{ paddingLeft: '4px' }}>
                                            {t(
                                                'consignmentBilling.inventory.href'
                                            )}{' '}
                                            {hrefId}{' '}
                                        </span>
                                    </Heading>
                                )}
                        </div>
                    </div>
                </div>
                <SubHeading isDemi>
                    {t('consignmentBilling.inventory.searchWithinInventory')}
                </SubHeading>
                <HighlightSearch
                    setSearchItem={props.setSearchItem}
                    setShowBtn={props.setShowBtn}
                />
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'inherit',
                        marginTop: '18px',
                    }}
                >
                    <StyledSortIcon>
                        <img src={SortGeneral} />
                    </StyledSortIcon>
                    <div>
                        <Select
                            id="consignmentBilling-inventorySearch-inventory-search"
                            height={'40px'}
                            width={'224px'}
                            placeholder={t(
                                'consignmentBilling.inventory.useByDateAscending'
                            )}
                            options={options}
                            value={selectedOption}
                            onChange={handleFilterChange}
                            scrollHeight={'365px'}
                            selectedLabelFontSize={'14px'}
                            labelColor={'#202124'}
                            hideClear={true}
                        />
                    </div>
                    {/* <SortContainer>Item # (Asending)</SortContainer> */}
                    <div>
                        <Button
                            id={
                                'consignmentBilling-inventorySearch-clearbtn-mobileview'
                            }
                            show
                            // secondary
                            variant={
                                props.filterCheckedItems &&
                                props.filterCheckedItems.length > 0
                                    ? ButtonStyles?.secondary
                                    : ButtonStyles?.disabled
                            }
                            width={'111px'}
                            mobileWidth={isLanguageChanged ? '78px' : '73px'}
                            height={'33px'}
                            clicked={clearSelectedClickHandler}
                            margin={'5px'}
                            mobileMargin={'5px 0px 5px 5px'}
                            WhiteSpace={'nowrap'}
                            fontSize={isLanguageChanged ? '12px' : '13px'}
                            border={'1px solid #EBEBEB'}
                            borderRadius={'20px'}
                            color={
                                props.filterCheckedItems &&
                                props.filterCheckedItems.length > 0
                                    ? '#1010EB'
                                    : '#B2B2B2'
                            }
                            disabled={
                                props.filterCheckedItems &&
                                props.filterCheckedItems.length > 0
                                    ? false
                                    : true
                            }
                        >
                            {t('consignmentBilling.inventory.clearAll')}
                        </Button>
                    </div>
                </div>
            </MobileSearch>
        </>
    );
};

export default InventorySearch;
